import React from 'react';
import type { FC } from 'react';

import { Button } from '../../ui/Button/Button';
import { Modal, ModalActions } from '../../ui/Modal/Modal';
import { IconSearch } from '../../../assets/icons/icons';

interface RestartSearchModalProps {
    open: boolean;
    submitting?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const RestartSearchModal: FC<RestartSearchModalProps> = ({
    open,
    submitting = false,
    onCancel,
    onConfirm,
}) => (
    <Modal
        open={open}
        width={420}
        title="Перезапустить поиск?"
        description="Обратите внимание, что поиск начнётся заново, ранее найденные предложения будут заменены."
        icon={<IconSearch />}
        onClose={onCancel}
        footer={
            <ModalActions>
                <Button onClick={onCancel} disabled={submitting}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={submitting}>
                    {submitting ? 'Перезапуск…' : 'Перезапустить'}
                </Button>
            </ModalActions>
        }
    />
);